import { Link } from "react-router-dom";

export const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="nav-brand-logo"
    className="flex items-center gap-2.5 group shrink-0"
    aria-label="Market Rounds — home"
  >
    <svg width="40" height="40" viewBox="0 0 28 28" fill="none" aria-hidden="true" className="shrink-0">
      <circle cx="11" cy="14" r="9" fill="#00F0FF" />
      <circle
        cx="17"
        cy="14"
        r="9"
        stroke={dark ? "#000000" : "#FFFFFF"}
        strokeWidth="2.5"
        fill="none"
        className="transition-colors duration-300"
      />
    </svg>
    <span className="leading-none select-none">
      <span
        className={`block text-xl sm:text-2xl font-semibold tracking-tight whitespace-nowrap transition-colors duration-300 ${
          dark ? "text-black" : "text-white"
        }`}
      >
        Market Rounds
      </span>
      <span
        className={`block text-center text-[11px] sm:text-xs font-semibold tracking-[0.2em] mt-1 whitespace-nowrap transition-colors duration-300 ${
          dark ? "text-zinc-500" : "text-zinc-400"
        }`}
      >
        Technologies<span className="text-cyan-400">.</span>
      </span>
    </span>
  </Link>
);

export default Logo;
